export default "__VITE_ASSET__B_IBJr8T__"